<details class="vendor-rejections" data-testid="vendor-rejections-accordion">
  <summary class="vendor-rejections__summary">
    Vendor Rejections
    <span class="vendor-rejections__count" data-testid="vendor-rejections-count"
      >({{ rejectedVendorCount() }})</span
    >
  </summary>

  <div class="vendor-rejections__list">
    @for (
      estimate of rejectedEstimates();
      track estimate.vendorId ?? estimate.estimationsId ?? $index
    ) {
      <div
        [attr.data-testid]="
          'vendor-rejection-item-' +
          (estimate.vendorId ?? estimate.estimationsId ?? $index)
        "
      >
        <app-quote-card
          [order]="order()"
          [estimate]="estimate"
          [readonlyMode]="true"
        />
      </div>
    }
  </div>
</details>
